export default "__VITE_ASSET__9rJWQua9__"